// src/Home.jsx
import React, { useRef, useState } from "react";
import Current from "./Current";
import Archive from "./Archive";

function Home() {
  const [activeFilter, setActiveFilter] = useState("category-all");
  const [showArchive, setShowArchive] = useState(false);
  const projectsRef = useRef([]); // shared between Current + Archive

  const filters = [
    { key: "category-all", label: "All" },
    { key: "category-dm", label: "Direct Mail" },
    { key: "category-logo", label: "Logo" },
    { key: "category-digital", label: "Digital" },
    { key: "category-concept", label: "Concept" },
    { key: "category-other", label: "Other" },
  ];

  const handleFilterClick = (filterKey) => {
    setActiveFilter(filterKey);
  };

  const handleArchiveToggle = () => setShowArchive((prev) => !prev);

  return (
    <div className="container-fluid pt-1">
      <div className="row">
        <div className="col">
          <div className="text-center">
            {filters.map(({ key, label }) => (
              <button
                key={key}
                className={`btn btn-default filter-button ${activeFilter === key ? "active" : ""}`}
                onClick={() => handleFilterClick(key)}
              >
                {label}
              </button>
            ))}
          </div>

          <div className="projects text-center">
            <div className="container-fluid">
              <div className="row">
                {/* ✅ Pass activeFilter + projectsRef */}
                <Current activeFilter={activeFilter} projectsRef={projectsRef} />
              </div>

              <button
                id="archive"
                type="button"
                className="btn btn-light m-3 border"
                onClick={handleArchiveToggle}
              >
                {showArchive ? "Show Less Creative" : "Show More Creative"}
              </button>

              {showArchive && (
                <div className="row">
                  {/* ✅ Pass activeFilter + projectsRef */}
                  <Archive activeFilter={activeFilter} projectsRef={projectsRef} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
